import Vue from 'vue'
import { ClientTable } from 'vue-tables-2'
import VueNotification from 'vue-notification'
import DatePicker from 'vue2-datepicker';

import App from '@/App.vue'
import store from '@/store'
import router from '@/router'

import('normalize.css')
import('@/assets/assets.scss')
import('@/assets/datepicker.scss')

Vue.use(ClientTable)
Vue.use(VueNotification)
Vue.use(DatePicker)

Vue.directive('click-outside', {
	bind: function (el, binding, vnode) {
		el.clickOutsideEvent = function (event) {
			// here I check that click was outside the el and his children
			if (!(el === event.target || el.contains(event.target))) {
				// and if it did, call method provided in attribute value
				vnode.context[binding.expression](event);
			}
		};
		document.body.addEventListener('click', el.clickOutsideEvent)
	},
	unbind: function (el) {
		document.body.removeEventListener('click', el.clickOutsideEvent)
	},
});

let app = '';

if (!app) {
    app = new Vue({
        store,
        router,
        render: h => h(App)
    }).$mount('#app')
}
